// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auto-suggest-input .react-autosuggest__input {
  border-radius: 0.3rem;
  font-size: 0.925rem;
  min-height: calc(2.1875rem + 2px);
  padding: 0.4rem 1rem;
  appearance: none;
  background-clip: padding-box;
  background-color: #fff;
  border: 1px solid #ced4da;
  border-radius: 0.2rem;
  color: #495057;
  display: block;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 0.3rem 0.85rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  width: 100%;
}
.auto-suggest-input .react-autosuggest__suggestions-container--open {
  border: 1px #e3e9ee solid;
  width: auto;
  background: #f8fafc;
  padding: 0px 0px;
  position: absolute;
  z-index: 99;
}
.auto-suggest-input .react-autosuggest__suggestions-list {
  list-style: none;
  font-size: 16px;
  margin: 0px;
  padding: 0px;
}
.auto-suggest-input .react-autosuggest__suggestions-list li {
  border-bottom: 1px solid #e3e9ee;
  padding: 5px 10px;
  color: rgb(114, 158, 196);
  cursor: pointer;
}
.auto-suggest-input .react-autosuggest__suggestions-list li:hover {
  background: #d6e0e9;
  font-weight: 500;
}
.auto-suggest-input .react-autosuggest__suggestions-list li:last-child {
  border: 0;
}`, "",{"version":3,"sources":["webpack://./src/components/EmployeeSearchInput/EmployeeSearchInput.scss"],"names":[],"mappings":"AAGQ;EACI,qBAAA;EACA,mBAAA;EACA,iCAAA;EACA,oBAAA;EAGA,gBAAA;EACA,4BAAA;EACA,sBAAA;EACA,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,wEAAA;EACA,WAAA;AAFZ;AAKQ;EACQ,yBAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AAHhB;AAKQ;EACI,gBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;AAHZ;AAIY;EACI,gCAAA;EACA,iBAAA;EACA,yBAAA;EACA,eAAA;AAFhB;AAGgB;EACI,mBAAA;EACA,gBAAA;AADpB;AAIgB;EACI,SAAA;AAFpB","sourcesContent":["\n.auto-suggest-input {  \n    .react-autosuggest {\n        &__input {\n            border-radius: 0.3rem;\n            font-size: .925rem;\n            min-height: calc(2.1875rem + 2px);\n            padding: 0.4rem 1rem;\n            -webkit-appearance: none;\n            -moz-appearance: none;\n            appearance: none;\n            background-clip: padding-box;\n            background-color: #fff;\n            border: 1px solid #ced4da;\n            border-radius: .2rem;\n            color: #495057;\n            display: block;\n            font-size: .875rem;\n            font-weight: 400;\n            line-height: 1.5;\n            padding: .3rem .85rem;\n            transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;\n            width: 100%;\n            \n        }\n        &__suggestions-container--open {\n                border: 1px #e3e9ee solid;\n                width: auto;\n                background: #f8fafc;\n                padding: 0px 0px;\n                position: absolute;\n                z-index: 99;\n        }\n        &__suggestions-list{\n            list-style: none;\n            font-size: 16px;\n            margin: 0px;\n            padding: 0px;\n            li {\n                border-bottom: 1px solid #e3e9ee;\n                padding: 5px 10px;\n                color:rgb(114, 158, 196);\n                cursor: pointer;\n                &:hover {\n                    background: #d6e0e9;\n                    font-weight: 500;\n                }\n\n                &:last-child {\n                    border: 0;\n                }\n            }\n        }\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
